import { useTranslation } from "@sagot/i18n";
import { Badge, Icon, Tooltip } from "@sagot/ui";
import type { AgentStatus } from "./agent-not-live-notice";

const K = "deployKnowledge.widgetStudio";

interface InstallBadgeProps {
  installed: boolean;
  agentStatus: AgentStatus | undefined;
}

/** Header status chip: a draft/paused agent can't serve the widget, so that outranks install detection. */
export function InstallBadge({ installed, agentStatus }: InstallBadgeProps) {
  const { t } = useTranslation();
  if (agentStatus === "draft" || agentStatus === "paused") {
    return (
      <Tooltip content={t(`${K}.agentNotLiveHint.${agentStatus}`)}>
        <Badge tone="warning" tabIndex={0} className="mt-1.5 shrink-0" data-testid="agent-not-live-badge">
          <Icon name="alert-triangle" className="size-3" />
          {t(`${K}.agentNotLive`)}
        </Badge>
      </Tooltip>
    );
  }
  return (
    <Badge tone={installed ? "success" : "neutral"} className="mt-1.5 shrink-0">
      <span className="dot" />
      {installed ? t(`${K}.installed`) : t(`${K}.notInstalled`)}
    </Badge>
  );
}
